import api from './api';

// 'TIMEOUT' is synthesized client-side by useProcessingStatus when the polling
// cap (MAX_POLLING_TIME) is hit without a terminal status. The server only
// ever returns 'UPLOADING' | 'PROCESSING' | 'READY' | 'FAILED'.
export type ProcessingStatusValue = 'UPLOADING' | 'PROCESSING' | 'READY' | 'FAILED' | 'TIMEOUT';

export interface ImageProcessingStatus {
  imageId: string;
  status: ProcessingStatusValue;
  thumbnailUrl?: string;
}

export interface ProcessingStatus {
  catalogId: string;
  status: ProcessingStatusValue;
  progress?: number;
  updatedAt?: string;
  thumbnailUrl?: string;
  renditions?: Array<{
    size: string;
    url: string;
    width?: number;
    height?: number;
  }>;
  imageStatuses?: ImageProcessingStatus[];
}

export const getProcessingStatus = async (catalogId: string, ownerId?: string | null): Promise<ProcessingStatus> => {
  const params = ownerId ? `?owner_id=${encodeURIComponent(ownerId)}` : '';
  const response = await api.get(`/api/processing/status/${catalogId}${params}`);
  return response.data;
};

export const getBatchProcessingStatus = async (catalogIds: string[]): Promise<ProcessingStatus[]> => {
  const response = await api.post('/api/processing/status/batch', { catalogIds });
  return response.data;
};

export const retryProcessing = async (catalogId: string): Promise<void> => {
  await api.post(`/api/processing/retry/${catalogId}`);
};

export interface ReapplyWatermarksResult {
  queued: number;
  skipped: number;
  message: string;
}

export const reapplyWatermarks = async (): Promise<ReapplyWatermarksResult> => {
  const response = await api.post('/api/processing/reapply-watermarks');
  return response.data;
};
